import { getUser } from '~/v2/helpers/workspace-helper'
import { isUserSuperAdmin } from '~/v2/helpers/workspace-helper'

export enum FEATURE_FLAGS {
  SCALIS_MATCHES,
  AI_MATCHING,
  CRM,
  NOTIFICATION_PREFERENCES,
  EMAIL_SETTINGS,
}

// Check for production environment
const isProduction = process.env.NODE_ENV === 'production'

const enabledFeatures: FEATURE_FLAGS[] = []

/**
 * Checks if a feature flag is enabled
 * @param featureFlag The feature flag to check
 * @returns boolean indicating if the feature is enabled
 */
const displayFeature = (featureFlag: FEATURE_FLAGS, user?: Awaited<ReturnType<typeof getUser>> | null): boolean => {
  // Environment variables take precedence for testing/overrides
  if (isProduction) {
    return enabledFeatures.includes(featureFlag) || (user ? isUserSuperAdmin(user) : false)
  }

  // In non-production environments, show all features by default
  return true
}

export { displayFeature }
